export default "__VITE_ASSET__a$NyF7BX__"